module.exports = __webpack_public_path__ + "img/tooltipicon1.da5d7db7.svg";